/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// React
import { useState } from 'react';

// Mantine
import { Box, Tooltip } from '@mantine/core';

// Components
import { Text, MintStatus } from '@components/atoms';

// Styles
import classes from './ViewDetails.module.css';

// Utils
import {
	getMintStatusLabel,
	getMintStatusType,
	truncateString,
} from '@utils/functions';

import useStore from '@store/index';

import { useTranslation } from 'react-i18next';

import { Datatable } from '@components/organisms';

// Datattable config
import { tableSchemaBase as columns } from './import-details.columns';
import { NOT_APPLICABLE } from '@config/constants/common';
import { DrawerProduction } from '../../DrawerProduction';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const ViewDetails = (props: {
	form: any;
	onCancel: () => void;
	onBack: () => void;
	data: any[];
	isLoading: boolean;
}) => {
	const { isLoading, data } = props;
	/* ********************************** Hooks ********************************* */
	const [openDrawer, setOpenDrawer] = useState(false);

	const { t } = useTranslation();

	const {
		productionStartMintsSortStatus,
		importHistorySelected,
		productionLineSelected,
		setProductionLineSelected,
	} = useStore();

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.containerViewDetails}>
			<DrawerProduction
				opened={openDrawer}
				onClose={() => {
					setOpenDrawer(false);
				}}
				position={'right'}
				data={productionLineSelected}
			/>

			<Box className={classes.content}>
				<Tooltip
					label={
						importHistorySelected &&
						importHistorySelected.lines &&
						importHistorySelected.lines.length +
							` ${t(
								'importHistories.importedProductionsWithName'
							)} ${importHistorySelected.filename}`
					}
					disabled={
						importHistorySelected &&
						importHistorySelected.filename &&
						importHistorySelected.filename.length < 30
					}
				>
					<Box className={classes.title}>
						{importHistorySelected &&
							importHistorySelected.lines &&
							importHistorySelected.lines.length +
								` ${t(
									'importHistories.importedProductionsWithName'
								)} ${truncateString(importHistorySelected.filename, 30)}`}
					</Box>
				</Tooltip>
				<Box
					className={classes.containerMintInformations}
				>
					<Box className={classes.colMintInformation}>
						<Text
							className={classes.mintInformartionTitle}
						>
							{t('global.importDate')}
						</Text>
						<Text
							className={classes.mintInformartionDate}
						>
							{`${importHistorySelected.importDate}`}
						</Text>
					</Box>
					<Box
						className={classes.borderColMintInformation}
					/>
					<Box className={classes.colMintInformation}>
						<Text
							className={classes.mintInformartionTitle}
						>
							{t('global.importStatus')}
						</Text>
						<MintStatus
							type={getMintStatusType(
								importHistorySelected.status
							)}
							children={
								importHistorySelected?.status
									? getMintStatusLabel(
											importHistorySelected.status
										)
									: NOT_APPLICABLE
							}
						/>
					</Box>
				</Box>
				<Box className={classes.contentItem}>
					<Datatable
						loading={
							isLoading ? isLoading.toString() : undefined
						}
						columns={columns}
						data={data}
						onRowClick={() => {}}
						onViewMore={(row: any) => {
							setProductionLineSelected(row);
							setOpenDrawer(true);
						}}
						style={{
							minHeight: '100%',
						}}
						height={250}
						selectedRecords={null}
						sortstatus={productionStartMintsSortStatus}
					/>
				</Box>
			</Box>
		</Box>
	);
};
